// extracted by mini-css-extract-plugin
module.exports = {"footbar":"styles_footbar__zvrg5","activeNavLink":"styles_activeNavLink__1uFRt"};